import useInfiniteScrollHook from 'react-infinite-scroll-hook';

interface UseInfiniteScrollOptions {
  disabled?: boolean;
  hasMore: boolean;
  isLoading: boolean;
  margin?: number;
  onFetchMore: () => void;
}

export function useInfiniteScroll({
  disabled,
  hasMore,
  isLoading,
  margin = 0,
  onFetchMore
}: UseInfiniteScrollOptions) {
  const [scrollTriggerRef] = useInfiniteScrollHook({
    disabled,
    hasNextPage: hasMore,
    loading: isLoading,
    onLoadMore: onFetchMore,
    rootMargin: `0px 0px ${margin}px 0px`
  });

  return scrollTriggerRef;
}
